import * as React from 'react';

import { PropertyInfoSubSectionViewModel } from 'models';

import { UitkHeading } from 'uitk-react-text';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutColumnsNoBreak } from 'uitk-react-layout-columns';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

import { SectionPlainList } from './section-list';

interface SectionsProps {
  section?: PropertyInfoSubSectionViewModel;
  dataStid: string;
  uitkHeadingLevel?: any;
  movePropertyTitle?: boolean;
  indentContent?: boolean;
}

export const Sections = ({ section, dataStid, uitkHeadingLevel = 4, movePropertyTitle, indentContent }: SectionsProps) => {
  if (!section || !dataStid) {
    return null;
  }

  return (
    <>
      {section.title &&
        section.formattedDescriptions &&
        section.formattedDescriptions.length > 0 && (
          <>
            {section.icon ? (
              <LayoutColumns section={section} uitkHeadingLevel={uitkHeadingLevel} dataStid={dataStid} />
            ) : (
              <ContinuousList
                section={section}
                uitkHeadingLevel={uitkHeadingLevel}
                dataStid={dataStid}
                movePropertyTitle={movePropertyTitle}
                indentContent={indentContent}
              />
            )}
          </>
        )}
    </>
  );
};

Sections.displayName = 'Sections';

export const LayoutColumns = ({ section, uitkHeadingLevel, dataStid }) => (
  <UitkLayoutColumnsNoBreak>
    <div className="all-y-padding-three">
      <UitkLayoutFlex>
        <UitkLayoutFlexItem shrink={1} className="all-r-padding-six">
          <UitkIcon name={section.icon} />
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <UitkHeading level={uitkHeadingLevel} size={500}>
            {section.title}
          </UitkHeading>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
      <div className="all-l-padding-twelve">
        {section.formattedDescriptions.map((formattedDescription, index) => (
          <SectionPlainList
            formattedDescription={formattedDescription}
            index={index}
            dataStid={dataStid}
            textType={formattedDescription.textType}
          />
        ))}
      </div>
    </div>
  </UitkLayoutColumnsNoBreak>
);

export const ContinuousList = ({ section, uitkHeadingLevel, dataStid, movePropertyTitle, indentContent }) => (
  <div className={`all-y-padding-three ${indentContent ? 'all-l-padding-twelve' : ''}`}>
    <UitkHeading level={uitkHeadingLevel} size={!movePropertyTitle ? 500 : 400}>
      {section.title}
    </UitkHeading>
    {section.formattedDescriptions.map((formattedDescription, index) => (
      <SectionPlainList
        formattedDescription={formattedDescription}
        index={index}
        dataStid={dataStid}
        textType={formattedDescription.textType}
      />
    ))}
  </div>
);
